import { isCreateLikeDiscoveryOption } from "../../utils/capabilityUi.js";

/**
 * Large option buttons for agent-driven discovery (primary command UI).
 * @param {{ compact?: boolean }} props
 */
export default function DiscoveryOptionGrid({
  options,
  onSelect,
  disabled,
  canCreate = true,
  hidden = false,
  compact = false,
}) {
  if (hidden || !options?.length) return null;

  if (compact) {
    return (
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-[10px] font-semibold uppercase tracking-widest text-slate-500 shrink-0">
          Suggested
        </span>
        {options.map((opt) => {
          const blocked = !canCreate && isCreateLikeDiscoveryOption(opt);
          return (
            <button
              key={opt.id}
              type="button"
              disabled={disabled || blocked}
              title={blocked ? "Not available for read-only admin" : opt.description || opt.label}
              onClick={() => onSelect?.(opt)}
              className="rounded-full border border-[rgb(var(--idaxis-accent-primary-rgb)/0.25)] bg-[rgb(var(--idaxis-accent-primary-rgb)/0.06)] px-2.5 py-1 text-[11px] font-medium text-slate-200 transition hover:border-[rgb(var(--idaxis-accent-primary-rgb)/0.45)] hover:bg-[rgb(var(--idaxis-accent-primary-rgb)/0.12)] disabled:cursor-not-allowed disabled:opacity-40"
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">Suggested actions</p>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {options.map((opt) => {
          const blocked = !canCreate && isCreateLikeDiscoveryOption(opt);
          return (
          <button
            key={opt.id}
            type="button"
            disabled={disabled || blocked}
            title={blocked ? "Not available for read-only admin" : undefined}
            onClick={() => onSelect?.(opt)}
            className="group flex flex-col items-start rounded-xl border border-[rgb(var(--idaxis-accent-primary-rgb)/0.2)] bg-gradient-to-br from-[rgb(var(--idaxis-accent-primary-rgb)/0.07)] to-transparent px-4 py-3 text-left transition hover:border-[rgb(var(--idaxis-accent-primary-rgb)/0.4)] hover:from-[rgb(var(--idaxis-accent-primary-rgb)/0.12)] disabled:cursor-not-allowed disabled:opacity-40"
          >
            <span className="text-sm font-semibold text-slate-100 group-hover:text-[rgb(var(--idaxis-accent-primary-rgb)/1)]">{opt.label}</span>
            {opt.description ? (
              <span className="mt-1 text-[11px] leading-snug text-slate-500 group-hover:text-slate-400">{opt.description}</span>
            ) : null}
            {blocked ? (
              <span className="mt-1 text-[10px] text-amber-400/90">Read-only — choose another path</span>
            ) : null}
          </button>
          );
        })}
      </div>
    </div>
  );
}
